<template>
  <DialogBox :show="true" :w="634">
    <div class="sign-wrap">
      <span class="close" @click="$emit('close')">&times;</span>
      <div v-show="picId">
        <strong class="tit">查看签收记录</strong>
        <div class="item">
          <div class="gray-font-12">签收时间：</div>
          <div class="content">{{ signTime | toShortDateTime }}</div>
        </div>
        <div class="item">
          <div class="gray-font-12">签收签名：</div>
          <div class="content">
            <img class="img" :src="picId" />
          </div>
        </div>
        <div class="btn-wrapper">
          <button class="btn btn-secondary blue" @click="$emit('close')">确认</button>
        </div>
      </div>
      <div v-show="!picId">
        <strong class="tit">确认签收</strong>
        <div class="desc">请于下方的签字方框内签名，点击确定后完成签收确认</div>
        <div class="canvas-wrap">
          <canvas id="myCanvas" :width="w" :height="h"></canvas>
        </div>
        <div class="btn-wrapper">
          <button class="btn btn-secondary" @click="clear">清空</button>
          <button class="btn btn-secondary blue" @click="affirm">确认</button>
        </div>
      </div>
    </div>
  </DialogBox>
</template>

<script>
import DialogBox from "@components/DialogBox.vue";

export default {
  components: { DialogBox },
  data() {
    return {
      ctx: {},
      w: 600,
      h: 300
    };
  },
  props: {
    picId: {
      type: String,
      default: "" // 预览的图片id
    },
    signTime: {
      type: Number,
      default: 0 // 预览时的签收时间
    }
  },
  mounted() {
    var start_x, start_y, move_x, move_y, end_x, end_y;
    var canvasDom = document.getElementById("myCanvas");
    this.canvasDom = canvasDom;
    var ctx = canvasDom.getContext("2d");
    this.ctx = ctx;
    ctx.lineWidth = 3;
    ctx.strokeStyle = "#3737A4";
    var t = canvasDom.getBoundingClientRect().top; //canvas上边距
    var l = canvasDom.getBoundingClientRect().left; //canvas做边距
    $("#myCanvas").bind("mousedown", function(e) {
      start_x = e.clientX - l;
      start_y = e.clientY - t;
      //开始本次绘画
      ctx.beginPath();
      //画笔起始点
      ctx.moveTo(start_x, start_y);
      //显示坐标
      //移动（pc）
      $("#myCanvas").bind("mousemove", function(e) {
        move_x = e.clientX - l;
        move_y = e.clientY - t;
        //根据鼠标路径绘画
        var imageData = ctx.getImageData(0, 0, 600, 300);
        for (var i = 0; i < imageData.data.length; i += 4) {
          // 当该像素是透明的,则设置成白色
          if (imageData.data[i + 3] == 0) {
            imageData.data[i] = 246; // R
            imageData.data[i + 1] = 247; // G
            imageData.data[i + 2] = 248; // B
            imageData.data[i + 3] = 255; // A
          }
        }
        ctx.putImageData(imageData, 0, 0);
        ctx.lineTo(move_x, move_y);
        //立即渲染
        ctx.stroke();
        //显示坐标
      });
    });
    //松开
    canvasDom.addEventListener("mouseup", function(e) {
      $("#myCanvas").unbind("mousemove");
    });
  },
  methods: {
    clear() {
      this.ctx.clearRect(0, 0, this.w, this.h);
    },
    affirm() {
      let vm = this;
      document.getElementById("myCanvas").toBlob(function(blob) {
        vm.$emit("affirm", blob);
      }, "image/png");
    }
  }
};
</script>

<style lang="less" scoped>
.sign-wrap {
  overflow: hidden;
  padding: 15px;
  .tit {
    font-size: 16px;
  }
  .item {
    margin-top: 10px;
    display: flex;
    .gray-font-12 {
      width: 70px;
    }
    .content {
      flex: 1;
      font-size: 12px;
      color: #ff2b55;
      .img {
        width: 480px;
        height: 240px;
        margin-bottom: 10px;
      }
    }
  }
  .desc {
    color: #ff6600;
    font-size: 12px;
    padding: 10px 0;
  }
  .canvas-wrap {
    background: rgb(246, 247, 248);
    border: 1px dashed #ccc;
    display: inline-block;
    #myCanvas {
      display: block;
    }
  }
  .btn-wrapper {
    margin-top: 10px;
    text-align: center;
    .btn {
      padding: 0 20px;
      margin-left: 10px;
    }
    .affirm {
      background: #346cb0;
      color: #fff;
    }
  }
}
</style>